<template>
  <v-chart
    v-loading="loading"
    style="width: 100%;height: 100%"
    :options="lineOption"
    :autoresize="true"
    :init-options="{ devicePixelRatio: 1 }"
  ></v-chart>
</template>

<script>
import { DeviceAlarmApi } from '@wiz-api/large-screen-management'
import { isArray, map, get, ceil } from 'lodash'

const deviceAlarmApi = new DeviceAlarmApi()

export default {
  name: 'lineChart',

  data() {
    return {
      loading: false,
      lineOption: {
        color: ['#95F8FE'],
        legend: {
          data: [],
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          top: 25,
          left: 10,
          right: 10,
          bottom: 20,
          containLabel: true,
        },
        dataZoom: {
          show: true,
          // start: 0,
          // end: 10,
          height: 15,
          bottom: '1%',
          textStyle: {
            color: 'rgba(255,255,255,0.6)',
          },
          borderColor: 'transparent',
          backgroundColor: 'rgb(49,98,135,0.3)',
          fillerColor: 'rgba(78,144,252,0.4)',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'white',
            },
          },
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '30%'],
          nameTextStyle: {
            fontSize: 12,
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            margin: 20,
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: 'rgba(255,255,255,0.1)',
            },
          },
          axisTick: {
            length: 5,
            show: false,
          },
        },
        series: [
          {
            name: '',
            type: 'line',
            smooth: 'none',
            symbol: 'none',
            lineStyle: {
              color: '#95F8FE',
              width: 1,
            },
            data: [],
          },
        ],
      }
    }
  },
  methods: {
    async initData(code) {
      this.loading = true
      const [err, res] = await deviceAlarmApi.getWaveDataByDeviceCode({
        deviceCode: code
      })
      if (!err && res) {
        const waveformDataJson = JSON.parse(res.waveformDataJson) || {}
        const waveData = get(waveformDataJson, 'waveData') || []
        const data = isArray(waveData) ? waveData : []
        this.lineOption.series[0].data = map(data, (item, index) => {
          return [index, item]
        })
        this.lineOption.yAxis.name = waveformDataJson?.waveunit
      } else {
        this.lineOption.series[0].data = []
        this.lineOption.yAxis.name = ''
      }
      this.loading = false
    },
  },
}
</script>
